



















































import { Component, Vue } from "vue-property-decorator";
import { orderIds } from "@/api/api.config";
@Component
export default class my_bookings extends Vue {
  isShow = true;
  show = false;
  loading = false;
  finished = false; //是否加载完成 加载完不在触发load事件
  refreshing = false; // 下拉状态
  // orderName = "订单已确认";
  userId: any = "";
  pageNum: any = 1;
  pageCount: any = 10;
  status: any = 0;
  list: any = [];
  // showPopup() {
  //   if (this.orderName == "订单已确认") {
  //     this.show = true;
  //   } else {
  //     this.show = false;
  //   }
  // }
  // { pageNumber: this.pageNum, pageSize: this.pageCount }
  // addCancel() {
  //   this.isShow = false;
  //   this.show = false;
  //   this.orderName = "订单待确认";
  // }
  orderIdsList() {
    orderIds({
      status: this.status,
      page: this.pageNum,
      size: this.pageCount,
    }).then((res) => {
      this.list = res.data.content;
      // console.log(this.list);
      // console.log(res.data.totalPages);
      if (res.data.totalPages === this.list.length) {
        this.finished = true;
      } else {
        this.finished = false;
      }
      this.pageNum++;
      this.refreshing = false;
      this.loading = false;
    });
  }

  onRefresh() {
    setTimeout(() => {
      this.list = [];
      this.pageNum = 1;
      this.orderIdsList();
    }, 1000);
  }
  mounted() {
    this.orderIdsList();
  }
  onLoad() {
    setTimeout(() => {
      orderIds({
        status: this.status,
        page: this.pageNum,
        size: this.pageCount,
      }).then((res) => {
        let datas = res.data.content;
        this.list = this.list.concat(datas);
        if (this.list.length < res.data.totalPages) {
          this.pageNum++;
          this.loading = false;
        } else {
          this.finished = true;
          this.loading = true;
        }
      });
    }, 500);
  }
  created() {
    this.userId = this.$route.query.userId;
  }
}
